function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickRosetteOutline = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SVG = require("../../SVG");
var _styles = require("../../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var TickRosetteOutline = exports.TickRosetteOutline = (0, _react.memo)(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? (0, _styles.getREM)(1.5) : _ref$size,
    color = _ref.color,
    style = _ref.style;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  return (0, _jsxRuntime.jsx)(_SVG.SVG.Svg, {
    viewBox: "0 0 60 60",
    testID: "TickRosetteOutline",
    style: [{
      width: size,
      height: size
    }, style],
    title: "tick rosette icon",
    children: (0, _jsxRuntime.jsxs)(_SVG.SVG.G, {
      transform: "matrix(2.5,0,0,2.5,0,0)",
      children: [(0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
        d: "M15.75,9.749l-3.981,5.308a.75.75,0,0,1-1.13.08L8.25,12.749",
        fill: "none",
        stroke: color != null ? color : colors.text,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }), (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
        d: "M10.73,1.357a1.63,1.63,0,0,1,2.54,0l1.512,1.881a1.629,1.629,0,0,0,1.446.6l2.4-.261a1.63,1.63,0,0,1,1.8,1.8l-.261,2.4a1.629,1.629,0,0,0,.6,1.446l1.881,1.512a1.63,1.63,0,0,1,0,2.54L20.761,14.78a1.632,1.632,0,0,0-.6,1.447l.261,2.4a1.629,1.629,0,0,1-1.8,1.8l-2.4-.261a1.628,1.628,0,0,0-1.446.6L13.27,22.64a1.629,1.629,0,0,1-2.54,0L9.219,20.76a1.631,1.631,0,0,0-1.447-.6l-2.4.261a1.628,1.628,0,0,1-1.8-1.8l.261-2.4a1.631,1.631,0,0,0-.6-1.447l-1.88-1.511a1.629,1.629,0,0,1,0-2.54l1.88-1.512a1.628,1.628,0,0,0,.6-1.446l-.261-2.4a1.629,1.629,0,0,1,1.8-1.8l2.4.261a1.632,1.632,0,0,0,1.447-.6Z",
        fill: "none",
        stroke: color != null ? color : colors.text,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      })]
    })
  });
});